import React, { FC } from 'react';
import { CityListItem } from 'entities/City/components';
import { ICity } from 'entities/City/City.models';

interface IComponentProps {
  items: ICity[];
  onUpdate: (id: number) => void;
}

export const CityList: FC<IComponentProps> = ({ items, onUpdate }) => {
  if (!items.length) {
    return <div className="ff-regular fs-m color-dark-grey">Список городов пуст.</div>;
  }

  return (
    <div>
      {items.map((item) => {
        return <CityListItem key={item.id} item={item} onUpdate={onUpdate} />;
      })}
    </div>
  );
};
